import Box from '@mui/material/Box';
import LoadingOverlay from './LoadingOverlay';

export default function LoadingBackdrop({
  loadingLabel = '',
  loadingComponent,
}) {
  return (
    <LoadingOverlay>
      {loadingLabel && <Box>{loadingLabel}</Box>}
      {loadingComponent && <Box>{loadingComponent}</Box>}
    </LoadingOverlay>
  );
}
